import { Box, Grid } from "@mui/material";
import "./style.scss";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Banner from "../../components/Banner";
import { API } from "../../utils/apiEndpoint";
import { useCallback, useEffect, useState } from "react";
import { Constant, formatMoney } from "../../utils/constant";
import { useNavigate } from "react-router-dom";
import PaletteFund from "../../components/PaletteFund";


// const relatedLinks = [
//   {
//     title: "Tham khảo thêm về bảo hiểm liên kết đơn vị của Manulife",
//     links: [
//       {
//         text: "Xanh Tương Lai",
//         url: "https://www.manulife.com.vn/vi/san-pham-bao-hiem/bao-hiem-lien-ket-dau-tu/bao-hiem-lien-ket-don-vi/xanh-tuong-lai.html",
//       },
//     ],
//   },
//   {
//     title: "Tham khảo thêm về bảo hiểm liên kết chung của Manulife",
//     links: [
//       {
//         text: "Xanh Ước Mơ",
//         url: "https://www.manulife.com.vn/vi/san-pham-bao-hiem/bao-hiem-lien-ket-dau-tu/bao-hiem-lien-ket-chung/xanh-uoc-mo.html",
//       }
//     ],
//   },
// ];

type FundItemProps = {
  header: string;
  value: string;
};

export function FundItem({ header, value }: FundItemProps) {
  return (
    <Box className="fund-item">
      <Box className="header">{header}</Box>
      <Box className="value">
        <span>{formatMoney(value)}</span>
        <span className="currency">VND</span>
      </Box>
    </Box>
  );
}

export function FundState({
  price,
  percent,
}: {
  price: number;
  percent?: string;
}) {
  return (
    <Box className="fund-state">
      <Box className="header">Thay đổi so với kỳ trước</Box>
      <Box className="value">
        <span>{formatMoney(price)}</span>
        <span className={`change ${price > 0 && "change-up"} ${price < 0 && "change-down"}`}>
          {price > 0 && <ArrowDropUpIcon />}
          {price < 0 && <ArrowDropDownIcon />}
          {percent}%
        </span>
      </Box>
    </Box>
  );
}

export function FundPalette({
  risk = 0,
  status = '',
}: {
  risk?: number;
  status?: string;
}) {
  const safeRisk = Math.min(Math.max(risk, 1), 5);
  const pointerLeft = `${(safeRisk - 1) * 20 + 10}%`;
  return (
    <PaletteFund
      pointerLeft={pointerLeft}
      status={status}
    />
  );
}

export default function Fund() {
  const navigate = useNavigate();
  const [funds, setFund] = useState<any[]>([]);

  // const mappingDataFund = (data: any[]) => {
  //   return data.map((item: any) => ({
  //     ...item,
  //     id: item?.fundId,
  //     title: item?.fundName,
  //     oldDate: item?.values[0]?.date,
  //     oldValue: item?.values[0]?.price,
  //     newDate: item?.values[1]?.date,
  //     newValue: item?.values[1]?.price,
  //   }));
  // };

  const mappingDataWithRisk = (data: any[], dataRisk: any[]) => {
    return data.map(item => {
      const match = dataRisk.find(b => b.fundId === item.fundId);
      return {
        ...item,
        risk: match?.risk ?? 0,
        status: match?.status ?? ''
      };
    });
  }

  const getFundPrices = useCallback(async () => {
    const jsonPath = await fetch(`${process.env.PUBLIC_URL || ''}/data/fund-risk.json`);
    const dataRisk: any = await jsonPath.json();
    fetch(API.fundPrices)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to getFundPrices");
        }
        return response.json();
      })
      .then((jsonData) => {
        // const fundData = mappingDataFund(jsonData);
        const result = mappingDataWithRisk(jsonData, dataRisk.data)
        console.log(result)
        setFund(result);
      })
      .catch((error) => {
        console.error("Error loading JSON:", error);
      });
  }, []);

  useEffect(() => {
    getFundPrices();
    const intervalGetFund = setInterval(() => {
      getFundPrices();
    }, Constant.interval);
    return () => {
      clearInterval(intervalGetFund);
    };
  }, [getFundPrices]);

  return (
    <Box className="main-fund">
      <Banner></Banner>
      <Grid container spacing={0}>
        <Grid size={{ md: 12, sm: 12 }}>
          <Box className="list-fund">
            <Box sx={{ marginBottom: '24px' }}>
              <p className="description">
                Giá đơn vị Quỹ áp dụng cho dòng sản phẩm Bảo Hiểm Liên Kết Đơn
                Vị Đóng Phí Định Kỳ được phân phối bởi Manulife Việt Nam.
              </p>
              <p className="description">
                {/* Giá Mua Đơn Vị Quỹ = Giá Bán Đơn Vị Quỹ = Giá trị tài sản ròng trên mỗi Đơn Vị Quỹ */}
                Giá đơn vị Quỹ được xác định bằng giá trị tài sản ròng (NAV) trên mỗi đơn vị, và đồng thời là giá mua và giá bán của đơn vị Quỹ.
              </p>
            </Box>
            {funds.map((fund: any, index: number) => (
              <Box
                key={index}
                className="accordion-funds border"
                onClick={() => {
                  // handleFundClick(fund);
                  navigate(`/detail/${fund.fundId}`);
                }}
              >
                <Grid container spacing={1}>
                  <Grid size={{ xl: 3, lg: 2, md: 12, sm: 12, xs: 12 }}>
                    <Box className="fund-title">
                      <Box>
                        <Box>{fund.fundName}</Box>
                        {fund.fundId === 'VNTCF' && <Box className="fund-subtitle">Tên gọi trước đây: Quỹ Liên Kết Đầu Tư Trái Phiếu Techcom</Box>}
                        {fund.fundId === 'VNTCM' && <Box className="fund-subtitle">Tên gọi trước đây: Quỹ Liên Kết Đầu Tư Tiền Linh Hoạt Techcom</Box>}
                        {fund.fundId === 'VNTCE' && <Box className="fund-subtitle">Tên gọi trước đây: Quỹ Liên Kết Đầu Tư Cổ Phiếu Techcom</Box>}
                      </Box>
                    </Box>
                  </Grid>
                  <Grid size={{ xl: 9, lg: 10, md: 12, sm: 12, xs: 12 }}>
                    <Grid container spacing={1}>
                      <Grid size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
                        <FundItem
                          header={`Giá đơn vị Quỹ ngày ${fund.values[0]?.date}`}
                          value={fund.values[0]?.buyPrice}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
                        <FundItem
                          header={`Giá đơn vị Quỹ ngày ${fund.values[1]?.date}`}
                          value={fund.values[1]?.buyPrice}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
                        <FundState
                          price={fund.fundChanged}
                          percent={fund.percentageChanged}
                        />
                      </Grid>
                      <Grid size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
                        <Box className="fund-item">
                          <Box className="header" textAlign={"center"}>Mức độ rủi ro</Box>
                          <Box>
                            <Box display="flex" alignItems="center" height="100%" marginTop="35px">
                              <FundPalette risk={fund.risk} status={fund.status} />
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
        </Grid>
        {/* <Grid size={{ md: 3, sm: 12 }}>
          <Box className="related-link">
            <Box sx={{ padding: "10px 0", marginBottom: "10px" }}>
              <hr />
            </Box>
            {relatedLinks.map((linkGroup, index) => (
              <Box key={index} className="related-links">
                <p className="related-title">{linkGroup.title}</p>
                <ul className="related-list">
                  {linkGroup.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link
                        title={link.text}
                        url={link.url}
                        icon={<KeyboardArrowRightIcon fontSize="small" />}
                      />
                    </li>
                  ))}
                </ul>
              </Box>
            ))}
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
}
